import React from 'react';
import PropTypes from 'prop-types';
import { Sidebar, Menu } from 'semantic-ui-react';
import SidebarHeader from './SidebarHeader';
import SidebarUpperMenu from './SidebarUpperMenu';
import SidebarLowerMenu from './SidebarLowerMenu';
import SidebarFooter from './SidebarFooter';

const sideBarStyle = {
  margin: '0px 0px',
  paddingLeft: '0px',
  width: '258px',
};

const sideBarMenuStyle = {
  margin: '0px 0px',
  padding: '0px 0px',
};

const SidebarContainer = ({ visible, toggleVisibility }) => (
  <Sidebar
    as={Menu}
    animation="uncover"
    direction="right"
    visible={visible}
    icon="labeled"
    vertical
    style={sideBarStyle}
  >
    <SidebarHeader closeSidebar={toggleVisibility} />
    <SidebarUpperMenu style={sideBarMenuStyle} />
    <SidebarLowerMenu style={sideBarMenuStyle} />
    <SidebarFooter />
  </Sidebar>
);

SidebarContainer.propTypes = {
  visible: PropTypes.bool.isRequired,
  toggleVisibility: PropTypes.func.isRequired,
};

export default SidebarContainer;



// WEBPACK FOOTER //
// ./src/app/components/Nav/MobileNav/Sidebar/SidebarContainer.js